// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose } from "recompose";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withLocalization from "../hocs/withLocalization";
import withErrorState from "../hocs/withErrorState";
import withLoadingState from "../hocs/withLoadingState";
import withFlattenedTranslations from "../hocs/withFlattenedTranslations";
import { withStyles } from "@material-ui/core/styles";
import withPodcasts from "../hocs/withPodcasts";
import Heading3 from "../styleguide/Heading3";
import Grid from "@material-ui/core/Grid";
import { getImageComponent } from "./PodcastsItem";
import formatDateTime from "../utils/formatDateTime";
import PlayIcon from "@material-ui/icons/PlayArrow";
import { Link } from "react-router-dom";
import buildAssetUrl from "../utils/buildAssetUrl";

const styles = (theme) => ({
    root: {
        width: "100%",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        boxShadow: "0 0 4px 0 #d6d8db",
        padding: 24,
    },
    title: {
        fontSize: 40,
        color: "#fff",
        textTransform: "uppercase",
        marginBottom: 20,
    },
    list: {
        display: "flex",
    },
    item: {
        color: "#fff",
        display: "flex",
    },
    itemTitle: {
        fontSize: 12,
        fontWeight: 700,
    },
    itemDate: {
        fontSize: 12,
    },
    itemImage: {
        minWidth: 102,
        width: 102,
        height: 102,
        marginRight: 8,
        position: "relative",
    },
    playIcon: {
        border: "1px solid #fff",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: 8,
        fontSize: 35,
        background: "rgba(0, 0, 0, 0.3)",
    },
});

const EntryScreenPodcasts = ({ classes, podcasts, entryScreen }) => {
    let imageUrl;
    if (entryScreen.teaserImage) {
        const { url } = buildAssetUrl(entryScreen.teaserImage);
        imageUrl = url;
    }

    return (
        <div className={classes.root} style={{ backgroundImage: `url(${imageUrl})` }}>
            <Heading3 bold className={classes.title}>
                <span>{entryScreen.title}</span>
            </Heading3>
            <Grid container={16}>
                {podcasts.slice(0, 4).map((podcast) => {
                    const image = getImageComponent(podcast.teaserImage);
                    const [formattedDate] = formatDateTime(podcast.publicationDate);
                    return (
                        <Grid key={podcast.id} item xs={3}>
                            <div className={classes.item}>
                                <Link to={`/buscast/${podcast.id}`} className={classes.itemImage}>
                                    {image}
                                    <div className={classes.playIcon}>
                                        <PlayIcon fontSize="inherit" color="secondary" />
                                    </div>
                                </Link>
                                <div>
                                    <div className={classes.itemTitle}>{podcast.title}</div>
                                    <div className={classes.itemDate}>{formattedDate}</div>
                                </div>
                            </div>
                        </Grid>
                    );
                })}
            </Grid>
        </div>
    );
};

export default compose(
    withConnectionStatus,
    withLocalization,
    withPodcasts(),
    withErrorState,
    withLoadingState("podcasts", "text"),
    withFlattenedTranslations("podcasts"),
    withStyles(styles)
)(EntryScreenPodcasts);



// WEBPACK FOOTER //
// ./src/components/EntryScreenPodcasts.js